import { Warning } from "@mui/icons-material"
import { Grid, Icon, Typography } from "@mui/material"
import { ImportValidationWarning } from "../../generated/graphql"
import styles from './ShowInterventionImportWarnings.module.scss'

interface ShowInterventionImportWarningsProps {
    warnings: ImportValidationWarning[]
}

const getWarningMessage = (error: ImportValidationWarning): string => {
    if (error.code === "DOCUMENT_ERROR") {
        return `Aviso na linha ${error?.address} ${error?.value}.`
    }
    if (error.code === "ROW_ERROR") {
        return `Aviso na linha ${error?.address} ${error?.value}.`
    }
    return `Aviso na célula ${error?.address} valor ${error?.value}.`
}

export default function ShowInterventionImportWarnings(props: ShowInterventionImportWarningsProps) {
    const { warnings } = props

    if (!warnings?.length) {
        return null
    }

    return (
        <div className={styles.Wrapper}>

            <Typography variant="h4" color="secondary">
                <Grid container alignItems="center" className={styles.Header}>
                    <Icon><Warning /></Icon> <span className={styles.Title}>Avisos</span>
                </Grid>
            </Typography>

            <Typography variant="body1" color="secondary">
                Por favor verifique com atenção as linhas que se seguem. <br /> Não submeta linhas que não cumpram as restrições, pois serão rejeitadas.
            </Typography>

            <div className={styles.WarningsList}>
                {
                    warnings.map(warning => (
                        <Typography variant="body1" color="warning" sx={{ color: '#FBC02D' }}>
                            {getWarningMessage(warning)}
                        </Typography>
                    ))
                }
            </div>
        </div>
    )
}
